"use strict";

exports.__esModule = true;
exports.default = void 0;
var _layout = require("../../utils/layout");
const getWidth = inline => (0, _layout.isDefined)(inline) && !inline ? "100%" : "";
var _default = getWidth;
exports.default = _default;